<div class="sidebar">
  <div class="files">
    <div class="files__heading">
      <p-skeleton></p-skeleton>
    </div>
    <div class="files__grid files-grid">
      <p-skeleton></p-skeleton>
      <p-skeleton></p-skeleton>
    </div>
  </div>
</div>
